import { useEffect } from "react";

/** Set a --scrollbar-thin-width CSS var. Allows us to set essentially build "overlay" sidebars by adjusting standard screen gutters. */
export const useProvideScrollbarWidth = () => {
  useEffect(() => {
    // we tried using a modern approach based on the container query scrollbar,

    const el = document.createElement("div");
    el.className = "scrollbar-measure scrollbar-thin";
    el.style.cssText = "overflow:scroll; visibility:hidden; position:absolute;";
    document.body.appendChild(el);
    const width = el.offsetWidth - el.clientWidth;
    el.remove();

    document.body.style.setProperty("--scrollbar-thin-width", `${width}px`);
  }, []);
};
